function escapeHtml(s) {
	if (s == null || s === '') return '—';
	return String(s)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

export function formatChatSessionDateTime() {
	try {
		return new Date().toLocaleString(undefined, {
			dateStyle: 'medium',
			timeStyle: 'short',
		});
	} catch (e) {
		return new Date().toISOString();
	}
}

export function readFullcontField(root, wrapperId) {
	if (!root || !wrapperId) return '';
	const wrap = root.querySelector(`#${wrapperId}`);
	if (!wrap) return '';
	const el = wrap.querySelector('input.elem, textarea.elem, select.elem');
	if (!el) return '';
	if (el.tagName === 'SELECT') {
		const opt = el.options[el.selectedIndex];
		return (opt && opt.text) ? String(opt.text).trim() : String(el.value || '').trim();
	}
	return String(el.value || '').trim();
}

export function countMultitableLines(root, containerId) {
	if (!root || !containerId) return 0;
	const cont = root.querySelector(`#${containerId}`);
	if (!cont) return 0;
	return cont.querySelectorAll('.line').length;
}

/** Nombre legible del módulo (evita mostrar códigos internos tipo "item", "sale"). */
export function friendlySectionName(dest) {
	const map = {
		item: 'Item',
		sale: 'Sale',
		purchase: 'Purchase',
		customer: 'Customer',
		provider: 'Provider',
		suggestion: 'Suggestion',
	};
	return map[dest] || dest || '—';
}

export function buildChatCardWarning(opts) {
    const entityDisplay = opts.entityDisplay || '—';
    const typeLabel = opts.typeLabel || '—';
    const recordId = opts.recordId != null && opts.recordId !== '' ? String(opts.recordId) : '—';
    const scopeNote = opts.scopeNote || '';
    const details = Array.isArray(opts.details) ? opts.details.filter((d) => d && d.label) : [];

    const when = formatChatSessionDateTime();

    // Inicio de la tabla
    let html = `
        <div class="chat-warning-table-container">
            <table class="chat-warning-table">
                <thead>
                    <tr>
                        <th>Date and time</th>
                        <th>Section</th>
                        <th>Query type</th>
                        <th>Ref. Number</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>${escapeHtml(when)}</td>
                        <td>${escapeHtml(entityDisplay)}</td>
                        <td>${escapeHtml(typeLabel)}</td>
                        <td>${escapeHtml(recordId)}</td>
                    </tr>
                </tbody>
            </table>`;

    // Si hay detalles adicionales, creamos otra sección de tabla
    if (details.length > 0) {
        html += `<table class="chat-warning-table mt-6">
                    <tbody>`;
        for (let i = 0; i < details.length; i += 2) { // De 2 en 2 para que parezca mini tabla
            const chunk = details.slice(i, i + 2);
            html += '<tr>';
            chunk.forEach((d) => {
                const v = d.value != null && String(d.value).trim() !== '' ? String(d.value).trim() : '—';
                html += `
                    <td class="chat-card-warning-k" style="width: 25%">${escapeHtml(d.label)}</td>
                    <td style="width: 25%">${escapeHtml(v)}</td>`;
            });
            // Rellenar celdas vacías si el número de detalles es impar
            if (chunk.length === 1) html += '<td></td><td></td>';
            html += '</tr>';
        }
        html += `</tbody></table>`;
    }

    // Nota de alcance (Scope) al final
    if (scopeNote) {
        html += `
            <div class="chat-card-warning-scope mt-8">
                <strong>Note:</strong> ${escapeHtml(scopeNote)}
            </div>`;
    }

    html += `</div>`;
    return html;
}
